// extracted by mini-css-extract-plugin
export default {"wrapper":"WalletBalance_wrapper__wIuI+","balanceVal":"WalletBalance_balanceVal__ZrIsT","walletIcon":"WalletBalance_walletIcon__VQrf7"};